import { getAxiosErrorDisplayMessage } from '@/utils/error-utils';
import { toast } from 'sonner';

function writeTab(tab: Window, title: string, message: string): void {
  tab.document.title = title;
  tab.document.body.innerHTML = `<p style="font-family: sans-serif; padding: 16px;">${message}</p>`;
}

export function startConnectInNewTab(input: { label: string; start: () => Promise<{ authUrl: string }> }): void {
  const { label, start } = input;
  const authTab = window.open('', '_blank');
  if (!authTab) {
    toast.error(`Popup blocked. Please allow popups and try Connect ${label} again.`);
    return;
  }

  writeTab(authTab, `Connecting ${label}...`, `Connecting ${label}...`);

  start().then(
    (result) => {
      authTab.location.replace(result.authUrl);
      authTab.focus();
    },
    (error: unknown) => {
      if (!authTab.closed) {
        writeTab(authTab, `${label} connection failed`, `Failed to start ${label} connection. You can close this tab.`);
      }
      toast.error(getAxiosErrorDisplayMessage(error, `Failed to start ${label} connection.`));
    }
  );
}
